import { useEffect, useState } from "react";

export default function SuccessPopup({ onClose }) {
  const [visible, setVisible] = useState(true);
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setClosing(true);

      setTimeout(() => {
        setVisible(false);
        onClose?.();
      }, 300); // zoom out duration
    }, 3000); // show for 2s

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/30 backdrop-blur-md">
      <div
        className={`relative w-[420px] max-md:w-[320px] bg-white rounded-3xl shadow-2xl p-10 text-center transition-all duration-300 ${
          closing ? "animate-zoomOut opacity-0 scale-90" : "animate-cloudIn"
        }`}
      >
        {/* Floating Icon */}
        <div className="absolute -top-8 left-1/2 -translate-x-1/2">
          <div className="h-20 w-20 rounded-full main-button shadow-xl flex items-center justify-center animate-float">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-12 w-12 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={3}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </div>
        </div>

        {/* Content */}
        <h2 className="mt-10 text-2xl max-md:text-xl  font-semibold text-gray-800">
          Login Successful!
        </h2>

        <p className="mt-2 text-gray-500">Welcome To Maxipitch!</p>
      </div>
    </div>
  );
}
